import React, { useState, useEffect } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellChip from '~/Common-Objects/UI/Chips/Upsell.jsx'
import './index.scss'

export default function Expander({
    expanded = false,
    onExpand,
    onCollapse,
    label,
    upsellLabel,
    showUpsell = false,
    children,
    isFirst = false,
    noMarginTop = false,
    dataCategory
}) {
    const [selected, setSelected] = useState(expanded)

    useEffect(() => {
        setSelected(expanded)
    }, [expanded])

    const handleChange = () => {
        const newSelected = !selected
        setSelected(newSelected)

        if (newSelected) {
            if (onExpand) onExpand()
        } else {
            if (onCollapse) onCollapse()
        }
    }

    let wrapperClass = 'expander-wrapper ' + (isFirst ? 'expander-wrapper-first' : '')

    let expanderClass = 'expander'
    if (selected) {
        expanderClass += ' expander-selected'
    }
    if (noMarginTop) {
        expanderClass += ' mar-t0'
        expanderClass += ' pad-t0'
    }

    return (
        <div className={wrapperClass} data-category={dataCategory}>
            <div className={expanderClass} onClick={handleChange}>
                <div className='expander-text'>{label}</div>
                {showUpsell && <UpsellChip className='expander-upsell'>{upsellLabel}</UpsellChip>}
                <div className='expander-icon'>
                    <Icons
                        icon='lineArrowDown'
                        className={selected ? 'rotateVertical' : ''}
                        style={{ display: 'flex' }}
                    />
                </div>
            </div>
            {/* The children stay in the page whether the section is open or not,
                so the opening and closing is left entirely to CSS. While it is
                closed they are hidden from the keyboard and from screen readers. */}
            <div className={'expander-children' + (selected ? ' expander-children-open' : '')}>
                <div className='expander-children-inner'>{children}</div>
            </div>
        </div>
    )
}
